import { AuthUser } from "@app/auth/model/auth-user";
import { createActionSet, createRequestAction } from "@app/root-store/actions/action-creators";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { UserRole } from "../../model/user-role";

/**
 * An action result that returns a collection of entities
 */
export interface BulkActionResult {
    userRoles: ClareDbCollection<UserRole>;
}

/**
 * @description Used in the action creators to generate an action type like:
 * "[Entity Management] Load Entity"
 */
const actionCategory = "UserRole";

export const loadUserRolesSet = createActionSet<{ authUser?: AuthUser }, BulkActionResult>(actionCategory, "Load");
export const { request: load, success: loadSuccess, failure: loadFailure } = loadUserRolesSet;
export const setCustomerRoleId = createRequestAction<{ customerRole: UserRole }>("Customer Role ID", "Load");
